import { useEffect, useState } from 'react'
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import {
	Casinos
} from './cs-connect';
import {
	View
} from 'react-native'
import { useCasinoContext } from './containers/CasinoContextProvider';
import moment from 'moment'
import { Root } from 'firestar';

interface KeyObject extends Root {
	
}

export default function Settings() {

	const [showLoader, setShowLoader] = useState(true)
	const { casino } = useCasinoContext()
	const [accessKeys, setAccessKeys] = useState<KeyObject[]>([])

	useEffect(() => {
		fetchAccessKey()
	}, [])

	if (showLoader === true) {
		return (
			<div style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center'
			}}>
				<progress />
			</div>
		)
	}

	return (
		<Paper style={{
			marginTop: 20
		}} elevation={0} variant='outlined'>
			<View style={{
				padding: 20,
				width: 700
			}}>
				<div style={{
					display: 'flex',
					flex: 1,
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: '1em 0em',
				}}>
					<div>
						<div><b>Access Keys</b></div>
						<div>Access keys are used for <b>Prepare Checkout</b> and <b>Claim Url for Auto Login.</b></div>
					</div>
				</div>
				{accessKeys.length == 0 ? (
					<div>
						<div><i>No keys found</i></div>
						<br />
					</div>
				) : accessKeys.map((accessKey) => (
					<Paper variant='outlined' style={{
						display: 'flex',
						flex: 1,
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
						padding: 15,
						marginBottom: '1em'
					}}>
						<div>
							<label>Key: {accessKey.id}</label>
							<div>Created On: {moment(accessKey.createdAt?.toDate()).format('MMM DD, YYYY • hh:mm A')}</div>
						</div>
						<button onClick={() => onClickRevoke(accessKey)}>Revoke</button>
					</Paper>
				))}
				<Button variant='outlined' onClick={onClickCreate}>Create</Button>
			</View>
		</Paper>
	)

	async function fetchAccessKey() {
		try {
			const response = await Casinos.getAccessKeys(casino.id)
			setAccessKeys(response.data)
			setShowLoader(false)

		} catch (error) {
			console.log('Error Getting Access Keys: ', error)
		}
	}

	async function onClickCreate() {

		setShowLoader(true)
		try {
			if (casino.id == null) throw new Error("Casino ID Not Found");
			await Casinos.createAccessKey(casino.id, {})
			await fetchAccessKey()
		} catch (error) {
			console.log('Error Creating Access Key ', error)
		}
		setShowLoader(false)
	}

	async function onClickRevoke(KeyObject: KeyObject) {
		setShowLoader(true)
		try {
			await Casinos.deleteAccessKey(casino.id, KeyObject.id)
			await fetchAccessKey()
			
		} catch (error) {
			console.log('Error Creating Access Key ', error)
		}
		setShowLoader(false)
	}
}
